import { SyncExternalStore } from '@egr/xbox/utils/SyncExternalStore';

export const errorDialogStore = new SyncExternalStore({
    debug: false,
    showDetails: false,
});

let userSelectRestore: string | undefined;

/** enables text selection too */
function enableDebugInfo(debug: boolean = true): void {
    errorDialogStore.updateState({ debug });
    if (debug) {
        userSelectRestore = document.body.style.userSelect;
        document.body.style.userSelect = 'auto';
    } else {
        document.body.style.userSelect = userSelectRestore ?? 'auto';
    }
}

export function useDebugShow(): boolean {
    const { debug } = errorDialogStore.useState(['debug']);
    return debug;
}

function getDebugTapCallback(callback: VoidFunction): VoidFunction {
    let tabs: number = 0;
    let timeout: number | undefined;
    return (): void => {
        window.clearTimeout(timeout);
        if (++tabs === 7) {
            callback();
        }
        timeout = window.setTimeout(
            (): void => {
                tabs = 0;
            },
            500
        );
    };
}

export const debugTap = getDebugTapCallback(enableDebugInfo);